import 'date-fns';
import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { format as formatDate, parse } from 'date-fns';

const DateRangePickerComponent = ({ value = null, format = 'dd/MM/yyyy', onChange }) => {
  const initialStartDate = value ? parse(value.split('-')[0], format, new Date()) : null;
  const initialEndDate = value ? parse(value.split('-')[1], format, new Date()) : null;

  const [startDate, setStartDate] = useState(initialStartDate ? formatDate(initialStartDate, format) : null);
  const [endDate, setEndDate] = useState(initialEndDate ? formatDate(initialEndDate, format) : null);

  const handleStartDateChange = (date) => {
    console.log('Handling start date change', date);
    const formattedStartDate = date ? formatDate(date, format) : null;
    console.log('Formatted start date:', formattedStartDate);
    setStartDate(formattedStartDate);
    updateDateRange(formattedStartDate, endDate);
  };

  const handleEndDateChange = (date) => {
    console.log('Handling end date change', date);
    const formattedEndDate = date ? formatDate(date, format) : null;
    console.log('Formatted end date:', formattedEndDate);
    setEndDate(formattedEndDate);
    updateDateRange(startDate, formattedEndDate);
  };

  const updateDateRange = (start, end) => {
    console.log('Updating date range with:', start, end);
    if (start && end) {
      onChange({
        target: {
          value: `${start}-${end}`,
        },
      });
    }
  };

  useEffect(() => {
    if (value) {
      console.log('VALUE PROP RECEIVED:', value);
      const [start, end] = value.split('-');
      const parsedStart = start ? parse(start, format, new Date()) : null;
      const parsedEnd = end ? parse(end, format, new Date()) : null;
      setStartDate(parsedStart ? formatDate(parsedStart, format) : null);
      setEndDate(parsedEnd ? formatDate(parsedEnd, format) : null);
    }
  }, [value, format]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justifyContent="space-around" spacing={2}>
        <Grid item>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format={format}
            margin="normal"
            label="Start Date"
            value={startDate ? parse(startDate, format, new Date()) : null}
            onChange={handleStartDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change start date',
            }}
            autoOk
          />
        </Grid>
        <Grid item>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format={format}
            margin="normal"
            label="End Date"
            value={endDate ? parse(endDate, format, new Date()) : null}
            onChange={handleEndDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change end date',
            }}
            autoOk
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export default DateRangePickerComponent;
